<template>
  <div class="accessories-container" v-loading.fullscreen.lock="fullscreenLoading">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <div class="card-title">
            配件详细
          </div>
          <div class="card-content" v-loading="loading">
            <div>
              <span style="color:#99a9bf">生产单号：</span>
              <span style="color:#409EFF;font-weight: 500">{{orderinfo.produnum}}</span>
              <span style="color:#99a9bf;margin-left: 20px">订单号：</span>
              <span>{{orderinfo.ordernum}}</span>
              <span style="color:#99a9bf;margin-left: 20px">详细地址：</span>
              <span>{{orderinfo.address}}</span>
              <span style="color:#99a9bf;margin-left: 20px">色板来源：</span>
              <span>{{orderinfo.source}}</span>
<!--              <span v-if="orderinfo.source===0">厂部标准色板</span>-->
<!--              <span style="color:#F56C6C" v-if="orderinfo.source===1">客户提供色板</span>-->
<!--              <span style="color:#F56C6C" v-if="orderinfo.source===2">厂部定制色板</span>-->
              <span style="color:#99a9bf;margin-left: 20px">设计师：</span>
              <span>{{orderinfo.designer}}</span>
            </div>
            <div style="margin-top: 20px">
              <span style="color:#99a9bf">接单日期：</span>
              <span>{{orderinfo.receive_time}}</span>
              <span style="color:#99a9bf;margin-left: 20px">拆单日期：</span>
              <span>{{orderinfo.split_time}}</span>
              <span style="color:#99a9bf;margin-left: 20px">排产日期：</span>
              <span>{{orderinfo.schedule_time}}</span>
              <span style="color:#99a9bf;margin-left: 20px">预计交期：</span>
              <span>{{orderinfo.planned}}</span>
            </div>
            <div style="padding-top: 30px;border-top: 1px solid #f5f7fa;margin-top:30px;">
              <el-form :inline="true" size="small" :model="searchForm">
                <el-form-item label="搜索关键字">
                  <el-input v-model="searchForm.search"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="getMaterialDetail" icon="el-icon-search">搜索</el-button>
                  <el-button @click="batchPrint" icon="el-icon-printer">批量打印</el-button>
                </el-form-item>
              </el-form>
                <div style="height: 490px;width: 100%" v-loading="materialloading">
                <pl-table
                  :key="tableKey"
                  height="490px"
                  :datas="materialTableData"
                  :data="materialTableData"
                  use-virtual
                  :pagination-show="false"
                  @selection-change="handleSelectionChange"
                  size="small"
                  :row-height="45">
                  <pl-table-column type="selection" align="center" width="50"></pl-table-column>
                  <pl-table-column prop="xuhao" :resizable="false" align="center" show-overflow-tooltip width="80" label="序号"></pl-table-column>
                  <pl-table-column prop="area" label="区域" width="100" show-overflow-tooltip :resizable="false"></pl-table-column>
                  <pl-table-column prop="type" :resizable="false" align="center" show-overflow-tooltip width="90" label="分类"></pl-table-column>
                  <pl-table-column prop="name" :resizable="false" width="120" show-overflow-tooltip align="center" label="名称"></pl-table-column>
                  <pl-table-column prop="material" :resizable="false" align="center" show-overflow-tooltip width="90" label="基材"></pl-table-column>
                  <pl-table-column label="规格" width="120" show-overflow-tooltip :resizable="false" align="center">
                    <template slot-scope="scope">
                      <span v-if="scope.row.high!=null&&scope.row.high!=''">{{scope.row.high}}</span>
                      <span v-if="scope.row.high!=null&&scope.row.high!=''">×</span>
                      <span v-if="scope.row.width!=null&&scope.row.width!=''">{{scope.row.width}}</span>
                      <span v-if="scope.row.width!=null&&scope.row.width!=''">×</span>
                      <span v-if="scope.row.ply!=null&&scope.row.ply!=''">{{scope.row.ply}}</span>
                    </template>
                  </pl-table-column>
                  <pl-table-column prop="num" :resizable="false" align="center" show-overflow-tooltip width="80" label="数量"></pl-table-column>
                  <pl-table-column prop="unit" :resizable="false" align="center" show-overflow-tooltip width="60" label="单位"></pl-table-column>
                  <pl-table-column prop="color" width="120" :resizable="false" show-overflow-tooltip label="颜色" align="center"></pl-table-column>
                  <pl-table-column prop="remark" min-width="100" :resizable="false" show-overflow-tooltip label="备注" align="center"></pl-table-column>
                  <pl-table-column label="出库状态" fixed="right" :resizable="false" width="90" align="center">
                    <template slot-scope="scope">
                      <el-tag size="mini" :disable-transitions="true" v-if="scope.row.omark===1">已出库</el-tag>
                      <el-tag size="mini" :disable-transitions="true" type="danger" v-if="scope.row.omark===0">未出库</el-tag>
                    </template>
                  </pl-table-column>
                </pl-table>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getErpOrderAccessoriesDetail, getErpOrderAccessoriesList, ErpOrderAccessoriesPrint } from '@/api/erp'
import { getLodop } from '@/common/Lodop/LodopFuncs'

export default {
  name: 'Accessories',
  computed: {
    user: getUser
  },
  data() {
    return {
      fullscreenLoading: false,
      orderid: '',
      loading: false,
      tableKey: '',
      materialloading: false,
      materialTableData: [],
      orderinfo: [],
      searchForm: {
        search: ''
      },
      multipleSelection: []
    }
  },
  created() {
    this.tempRoute = Object.assign({}, this.$route)
    this.orderid = this.$route.params && this.$route.params.id
    this.getInfo()
  },
  methods: {
    getInfo() {
      this.loading = true
      getErpOrderAccessoriesDetail({ orderid: this.orderid }).then(response => {
        this.orderinfo = response.data
        const pageTitle = `配件详细 ${response.data.produnum}`
        document.title = pageTitle
        const route = Object.assign({}, this.tempRoute, { title: pageTitle })
        this.$store.dispatch('tagsView/updateVisitedView', route)
        this.loading = false
        this.getMaterialDetail()
      }).catch(() => {
        this.loading = false
      })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    getMaterialDetail() {
      this.materialTableData = []
      this.materialloading = true
      const data = {
        orderid: this.orderid,
        content: this.searchForm.search
      }
      getErpOrderAccessoriesList(data).then(response => {
        this.tableKey = new Date().getTime()
        this.materialTableData = response.data
        this.materialloading = false
      }).catch(() => {
        this.materialloading = false
      })
    },
    batchPrint() {
      const LODOP = getLodop()
      if (LODOP !== null && LODOP !== undefined) {
        if (this.multipleSelection.length > 0) {
          let mdids = []
          for (let m of this.multipleSelection) {
            if (m.mdid !== null && m.mdid !== '' && m.mdid !== undefined) {
              mdids.push(m.mdid)
            }
          }
          if (mdids.length > 0) {
            this.fullscreenLoading = true
            ErpOrderAccessoriesPrint({ orderid: this.orderid, mdids: mdids.join(',') }).then(response => {
              LODOP.PRINT_INIT('配件清单打印')
              LODOP.SET_PRINT_PAGESIZE(1, 0, 0, 'A4')
              LODOP.SET_PRINT_MODE('PRINT_PAGE_PERCENT', 'Auto-Width')
              LODOP.ADD_PRINT_TABLE(30, '11mm', '100%', '100%', response.data)
              LODOP.SET_PRINT_STYLEA(0, 'HOrient', 3)
              LODOP.SET_PRINT_STYLEA(0, 'VOrient', 3)
              LODOP.SET_SHOW_MODE('LANDSCAPE_DEFROTATED', 1)
              LODOP.NewPageA()
              LODOP.SET_PRINT_STYLEA(0, 'HtmWaitMilSecs', 100)
              LODOP.PREVIEW()
              this.fullscreenLoading = false
            }).catch(() => {
              this.fullscreenLoading = false
            })
          } else {
            this.$message.error('至少选择一个配件打印')
          }
        } else {
          this.$message.error('至少选择一个配件打印')
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.accessories-container{

}
</style>
